import React from 'react';

import FeedbackBar from "../feedbackBar/FeedbackBar";

import { hideError, showErrorMessage } from "../../redux/actions/global";
import { errorMessageSelector, showErrorSelector } from '../../redux/selectors/global';
import withShipment from '../../withShipment';

class ErrorFeedbackBar extends React.PureComponent {

    render() {
        return (
            <>
                <FeedbackBar
                    open={this.props.error}
                    severity="error"
                    message={this.props.errorMessage}
                    handleClose={this.props.hideError}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    error: showErrorSelector(state),
    errorMessage: errorMessageSelector(state)
})

const actionCreators = {
    hideError,
    showErrorMessage
}

ErrorFeedbackBar.propTypes = {
}

ErrorFeedbackBar.defaultProps = {
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, ErrorFeedbackBar);